import { BaseModelDto } from '../base-model/base-model.dto';
import { PoliticaPermissaoStatus } from './politica-permissao-status.enum';

export class PoliticaPermissaoDto extends BaseModelDto {
  id: number;
  politicaId: number;
  permissaoId: number;
  status: PoliticaPermissaoStatus;
}
